// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-content {
  position: relative;
  width: 568px !important;
  height: 413px;
  text-align: center;
  margin: 0 auto;
  /* background-image: url("../../assets/images/modal-bg.png"); */
  background-size: 45%;
  background-position: center;
  background-repeat: no-repeat;
  border-radius: 21px !important;
  border: none !important;
}


.modal-lotte-wrap{
  width: 300px;
  height: 250px;
}

.modal-side-image-wrap {
  position: absolute;
  top: -80px;
  left: -50px;
}

.modal-main-wrapper h4 {
  font-size: 26px;
  color: #383838;
  margin-top: 15px;
}

p.contract-modal-text {
  color: #383838 !important;
  font-size: 24px;
  width: 95%;
  margin-top: 15px !important;
}

.modal-header .btn-close {
  border: 3px solid #5e5e5e;
  border-radius: 100%;
  outline: none;
  font-size: 15px;
  color: #5e5e5e;
  font-weight: 900;
}

.modal-header {
  padding: 2rem 2rem;
}

.modal-header img {
  text-align: left;
  position: absolute;
  right: 20px;
  right: 25px;
  top: 15px;
  width: 35px;
  cursor: pointer;
}

.modal-header .btn-close:hover {
  border: 3px solid #000;
}

.btn-close:focus {
  box-shadow: none;
}

.modal-header {
  border-bottom: none;
}

.modal-main-wrapper h3 {
  width: 80%;
  font-size: 22px;
  line-height: 36px;
  color: #7E7E7E;
  font-family: 'Montserrat';
  text-align: center;
  font-weight: 500;
  margin-top: 30px;
}

.modal-main-wrapper .cancel-btn img {
  position: absolute;
  top: 0px;
  right: 10px;
  width: 40px;
  cursor: pointer;
}

.modal-main-wrapper img {
  width: 100px;
  margin-top: 50px;
}

.activate-modal-img {
  width: 120px;
  margin-top: 20px !important;
}

.modal-side-image-wrap img {
  width: 122px;
}

img.dany-modal-img {
  width: 130px;
  margin-top: -50px;
}

.modal-main-wrapper p {
  color: #818181;
  font-size: 21px;
  margin-top: 30px;
  width: 90%;
}

.modal-main-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.create-pin-wrap {
  margin-top: 20px;
}

.Re-enter-pin {
  margin-top: 30px;
}

.create-pin-wrap h2,
.Re-enter-pin h2 {
  font-size: 25px;
  color: #383838;
  padding-bottom: 4px;
}

.Re-enter-pin p {
  padding-top: 10px;
  font-size: 14px;
  color: red;
}

.confirm-button button {
  background: var(--buttonColor);
  border-radius: 5px;
  opacity: 1;
  border: none;
  color: #383838;
  padding: 9px 35px;
  margin-top: 20px;
}
.confirm-button button:hover {
  background: var(--buttonHover);
}

.modal-confirm-button button {
  background: var(--buttonColor);
  border-radius: 5px;
  opacity: 1;
  border: none;
  color: #383838;
  padding: 9px 35px;
  margin-top: 15px;
  font-size: 20px;
  font-weight: 400;
}

button.loding-btn {
  padding: 0px 35px;
}

.modal-confirm-button button img {
  width: 74px;
  height: 50px;
  padding: 0px;
  margin-top: 0px;
}

.modal-confirm-button button:hover {
  background: var(--buttonHover);
}

.modal-confirmation-button{
  width: 480px;
  display: flex;
  align-items: center;
  justify-self: center;
  gap: 20px;
}


.modal-confirmation-button button {
  width: 100%;
  height: 55px;
  border: none;
  border-radius: 11px;
  font-size: 20px;
}

.confirmation-modal-wrap{
  display: flex;
  margin-top: 100px;   
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 90px;
}

button.confirm-btn {
  background: #00A19B;
  color: #fff;
}

button.confirm-btn:hover{
  background: #fff;
  color: #383838;
  border: 2px solid #00A19B;
}

button.cancel-btn{
  background: #BFBFBF;
  color: #383838;
}

button.cancel-btn:hover{
  background: #fff;
  color: #383838;
  border: 2px solid #BFBFBF;
}

@media (max-width: 767px) {
  .modal-content{
    width: 95%;
    height: 400px;
  }


  .modal-side-image-wrap img {
    width: 100px;
  }

  .modal-lotte-wrap {
    width: 270px;
    height: 240px;
}

  .modal-main-wrapper h3 {
  font-size: 22px;
  }

  .modal-side-image-wrap {
    position: absolute;
    top: -75px;
    left: -39px;
  }
}


@media (min-width: 1600px) {
  .modal-confirm-button button {
    font-size: 20px;
    font-weight: 600;
  }

  .modal-header img {
    width: unset;
  }

  .activate-modal-img {
    width: 180px;
    margin-top: 50px;
  }


  img.dany-modal-img {
    width: 150px;
    margin-top: -50px;
  }

  p.contract-modal-text {
    color: #383838 !important;
    font-size: 31px;
  }

  .modal-main-wrapper h4 {
    font-size: 34px;
    margin: 30px 0px;
  }

  .modal-content {
    width: 568px;
    height: 413px;
  }
}

@media (min-width: 1920px) {
  .modal-confirm-button button {
    font-size: 20px;
    font-weight: 600;
  }
  .modal-content {
    width: 568px;
    height: 413px;
  }


  .activate-modal-img {
    width: 180px;
    margin-top: 50px;
  }

  .modal-main-wrapper img {
    width: 130px;
    margin-top: 50px;
  }

  img.dany-modal-img {
    width: 220px;
    margin-top: -30px;
  }

  .modal-main-wrapper p {
    color: #818181;
    font-size: 30px;
  }

  p.contract-modal-text {
    color: #383838 !important;
    font-size: 28px;
    font-weight: 500;
    width: 90%;
  }

  .modal-header .btn-close {
    border: 4px solid #5e5e5e;
    font-size: 20px;
    padding: 8px;
  }

  .modal-header .btn-close:hover {
    border: 4px solid #000;
  }
}




/************ Cleaning yfos modal css here ****/

.confirmation-modal-main-wrapper .modal-content {
    position: relative;
    min-width: 568px;
    height: 310px;
    background: #FFFFFF;
    border-radius: 34px;
    border: none;
}

.term-modal-main-wrapper .modal-content {
    position: relative;
    width: 450px;
    height: 400px;
    background: #FFFFFF;
    border-radius: 10px;
    border: none;
}


.modal-lg, .modal-xl {
    --bs-modal-width: unset;
}

.confirm-modal-main-wrap {
    width: 87%;
    margin: 0 auto;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.term-modal-main-wrap {
    width: 86%;
    margin: 0 auto;
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.modal-logo-wrap img {
    width: 112px;
    position: absolute;
    top: -36px;
    left: -40px;
}


.confirm-modal-main-wrap .modal-content {
    width: 568px;
    height: 309px;
}

.confirm-tick-image {
    margin-bottom: 10px;
}


.confirm-tick-image img {
    width: 116px;
    height: 116px;
}


.confirm-tick-image h4 {
    font-size: 56px;
    color: #00A19B;
    font-weight: 700;
    margin-top: 30px;
}

.confirm-modal-content-wrap h3 {
    font-size: 26px;
    font-family: "Montserrat", sans-serif;
    color: #1A1919;
    font-weight: 700 !important;
    margin-bottom: 10px;
}

.confirm-modal-content-wrap p {
    font-size: 22px;
    color: #1A1919;
    font-weight: 400;
    margin: 0 auto;
}

.percentage-modal-content-wrap h3 {
    font-size: 25px;
    color: #1A1919;
    font-weight: bold;
    margin: 0px;
    /* text-align: left; */
    margin-bottom: 15px;
}

.percentage-modal-image{
    margin-top: 30px;
    margin-bottom: 12px;
}

.percentage-modal-image h4 {
    font-size: 60px;
    color: #00A19B;
    font-weight: bold;
    /* text-align: left; */
    margin: 0px;
    padding-bottom: 8px;
}

.percentage-modal-content-wrap p {
    font-size: 14px;
    font-weight: 400;
    margin: 0px;
    text-align: left;
}

.percentage-modal-content-wrap span {
    font-size: 14px;
    font-weight: 400;
    color: #00A19B;
    font-style: italic;
    margin: 0px;
    text-align: left;
}

.percentage-modal-content-wrap {
    position: relative;
}

.percentage-item-warp {
    /* display: flex; */
    display: none;
    align-items: center;
    gap: 2px;
    position: absolute;
    right: -40px;
    top: 80px;
}

.percentage-item-warp p{
    font-size: 14px;
    color: #1A1919;
    font-weight: 600;
    margin-top: 10px;
}

.percentage-item-warp img{
    width: 40px;
}

.close-icon-wrap {
    position: absolute;
    top: 26px;
    right: 40px;
    z-index: 999;
}

.close-icon-wrap img{
    width: 32px;
    cursor: pointer;
}


.cancel-modal-main-wrap {
    width: 80%;
    margin: 0 auto;
    text-align: left;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.cancel-modal-content-wrap {
    margin-top: 70px;
}

.cancel-modal-content-wrap h3 {
    font-size: 25px;
    color: #1A1919;
    font-weight: bold;
    text-align: left;
}

.cancel-modal-content-wrap label {
    font-size: 16px;
    color: #1A1919;
    font-weight: 400;
    margin: 0px;
}

/* CancelOrderModal.css */

.cancelorder-modal-main-wrapper .modal-content {
    position: relative;
    width: 568px;
    height: 780px;
    background: #FFFFFF;
    border-radius: 34px;
    border: none;
}

.cancel-order-reason-wrapper{
    margin-top: 40px;
}

.radio-option {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
  }
  
  .radio-option input[type="radio"] {
    display: none;
  }
  
  .radio-option label {
    position: relative;
    padding-left: 30px;
    cursor: pointer;
    -webkit-user-select: none;
            user-select: none;
  }
  
  .radio-option label::before {
    content: "";
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 20px;
    height: 20px;
    border: none;
    border-radius: 50%;
    background-color: #F3F3F3;
  }
  
  .radio-option input[type="radio"]:checked + label::before {
    background-color: #00A19B; /* Change this color to the desired background color when checked */
    border-color: #4caf50;
    border: 2px solid #F3F3F3;
  }



  /************* Change select box backround ****/

  .term-modal-checkmark-wrap {
    display: flex;
    gap: 36px;
    margin-bottom: 16px;
}

.term-modal-checkmark-wrap p{
    font-size: 14px;
    font-weight: 400;
    margin: 0px;
    color: #626262;
}

.term-modal-checkmark-wrap p a{
    color: #00A19B !important;
    text-decoration: underline !important;
}



  .checkbox-container {
    display: inline-block;
    position: relative;
    margin-bottom: 0px;
    cursor: pointer;
    font-size: 14px;
    color: #1A1919;
    -webkit-user-select: none;
            user-select: none;
  }
  
  .checkbox-container input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }
  
  .checkbox-container .checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 22px;
    width: 22px;
    background-color: #f3f3f3; /* default gray background */
    border-radius: 0px;
    border: none;
  }

  span.error-msg.checkmark {
    border: 1px solid #FF0000 !important;
}
  
  .checkbox-container input:checked ~ .checkmark {
    background-color: #00A19B; /* background color when checked */
  }
  
  .checkbox-container .checkmark:after {
    content: "";
    position: absolute;
    display: none;
  }
  
  .checkbox-container input:checked ~ .checkmark:after {
    display: block;
  }
  
  .checkbox-container .checkmark:after {
    left: 9px;
    top: 5px;
    width: 5px;
    height: 10px;
    border: solid white;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
  }
  

.cancel-booking-main-wrap textarea {
    border: none;
    border-radius: 20px;
    background-color: #F3F3F3;
    width: 404px;
    height: 166px;
    resize: none;
    padding: 20px;
    outline: none;
}

.disable-textarea{
    opacity: 0.6;
}

.cancel-booking-main-wrap textarea::placeholder{
    font-size: 16px;
    color: #D5D5D5;
    font-weight: 400;
}

.cancel-booking-btn{
    margin-top: 20px;
}


.specaility-modal-content-wrap {
    text-align: left;
    margin-top: 50px;
}

.specaility-modal-content-wrap h3 {
    font-size: 25px;
    font-weight: bold;
    margin: 0px;
    padding-bottom: 8px;
}

.specaility-modal-content-wrap p {
    font-size: 14px;
    color: #1A1919;
    font-weight: 400;
    margin: 0px;
}

.modal-leave-stay-btn-wrap{
    margin-top: 50px;
}

.modal-leave-stay-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    margin-top: 10px;
}

.modal-leave-stay-btn button{
    height: 49px;
    width: 50%;
}

.term-modal-content-wrap {
    text-align: left;
}

.term-modal-content-wrap h3 {
    font-size: 22px;
    color: #1A1919;
    font-weight: 600;
    margin: 0px;
}

.term-modal-content-wrap p {
    font-size: 14px;
    color: #1A1919;
    font-weight: 400;
    margin: 0px;
}


.term-modal-content-wrap img {
    width: 22px;
    margin-bottom: 10px;
    margin-top: 10px;
}

.term-condition-content{
    margin-top: 12px;
}

.term-condition-content p {
    font-size: 14px;
    color: #626262;
    font-weight: 400;
    margin: 0px;
    text-align: left;
}

.pay-modal-term-wrapper{
    margin-top: 40px;
}

.pay-modal-term-wrapper label{
    font-size: 14px;
    color: #626262;
    font-weight: 400;
    margin: 0;
}

.pay-modal-term-wrapper label a {
    color: #00A19B !important;
    text-decoration: underline !important;
}

/******* TwoFa Confirmation Modal css *****/
.two-confirmation-modal-main-wrapper .modal-content {
    position: relative;
    min-width: 568px;
    height: 310px;
    background: #FFFFFF;
    border-radius: 34px;
    border: none;
}

.two-confirmation-modal-main-wrapper .modal-body{
    padding: 0px;
}

.twofa-confirm-modal-main-wrap {
    width: 87%;
    margin: 0 auto;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}


.modal-logo-wrap img {
    width: 112px;
    position: absolute;
    top: -36px;
    left: -40px;
}

.twofa-confirm-tick-image img {
    width: 205px;
}

.twofa-confirm-modal-content-wrap p {
    font-size: 22px;
    width: 80%;
    color: #1A1919;
    font-weight: 500;
    line-height: normal;
    margin: 0 auto;
}

p.error-msg {
    font-size: 14px;
    color: #FF0000;
    margin: 0px;
    overflow: hidden;
}
p.error-msg-empty{
    opacity: 0;
    margin: 0px;
}

/******* Resposive css ****/
@media (max-width: 1024px) {
    .two-confirmation-modal-main-wrapper .modal-content {
        position: relative;
        min-width: 90%;
        height: 240px;
        margin: 0 auto;
        border-radius: 23px;
    }

    .twofa-confirm-tick-image img {
        width: 156px;
    }

    .fade.modal.show {
        z-index: 999999;
    }

    .confirmation-modal-main-wrapper .modal-content {
        position: relative;
        min-width: 90%;
        height: 240px;
        margin: 0 auto;
        border-radius: 23px;
    }

    .speciality-modal-main-wrapper .modal-content {
        height: 290px;
    }

    .specaility-modal-content-wrap h3 {
        font-size: 18px;
        font-weight: bold;
    }

    .specaility-modal-content-wrap {
        margin-top: 36px;
    }

    .modal-leave-stay-btn-wrap {
        margin-top: 40px;
    }

    .close-icon-wrap {
        position: absolute;
        top: 16px;
        right: 20px;
    }

    .confirm-modal-content-wrap h3 {
        font-size: 20px;
        font-weight: bold;
        margin-bottom: 5px;
    }

    .confirm-modal-content-wrap p {
        font-size: 16px;
    }

    .confirm-tick-image h4 {
        font-size: 50px;
        margin-top: 20px;
        margin-bottom: 0px;
    }

    .confirm-tick-image {
        margin-bottom: 0px;
    }

    .modal-logo-wrap img {
        width: 80px;
        position: absolute;
        top: -30px;
        left: -12px;
    }

    .confirm-tick-image img {
        width: 90px;
        height: 90px;
    }

    .percentage-modal-image h4 {
        font-size: 40px;
        font-weight: bold;
    }

    .percentage-modal-content-wrap h3 {
        font-size: 16px;
        margin-bottom: 8px;
    }

    .percentage-item-warp {
        display: none;
    }

    .percentage-modal-image {
        margin-top: 10px;
        margin-bottom: 4px;
    }

    .confirm-modal-main-wrap {
        width: 86%;
    }

    .percentage-modal-main-wrapper .modal-content {
        position: relative;
        min-width: 90%;
        height: 270px;
    }

    .term-modal-main-wrapper .modal-content {
        width: 100%;
        height: 430px;
    }

    .pay-modal-term-wrapper {
        margin-top: 30px;
    }

    .term-modal-main-wrapper .pay-button-wrapper button {
        height: 49px;
        font-size: 14px;
    }

    .term-modal-main-wrapper .pay-button-wrapper {
        margin-top: 14px;
    }

    .cancelorder-modal-main-wrapper .modal-content {
        position: relative;
        width: 100%;
        min-height: 100vh;
    }

    .cancelorder-modal-main-wrapper .modal-body {
       background: #fff;
    }

    .mobile-cancel-modal-head {
        display: flex;
        align-items: flex-start;
        gap: 10px;
    }

    .cancel-modal-content-wrap h3 {
        font-size: 20px;
        font-weight: 600;
        margin-bottom: 0px;
    }

    .cancel-booking-main-wrap textarea {
        width: 100%;
        height: 220px;
    }

    .cancel-modal-main-wrap {
        width: 100%;
    }

    .cancel-modal-content-wrap {
        margin-top: 40px;
    }

    .mobile-cancel-modal-head img {
        width: 36px;
    }

    .twofa-confirm-modal-content-wrap p {
        font-size: 16px;
        width: 90%;
    }

  }

  @media(max-width: 360px){
    .term-modal-main-wrapper .modal-content {
        height: 460px;
    }
  }
  
  
@media(max-width: 340px){
    .confirm-modal-main-wrap {
        width: 94%;
    }

    .percentage-modal-content-wrap h3 {
        font-size: 15px;
    }

    .percentage-modal-main-wrapper .modal-content {
        position: relative;
        width: 90%;
        height: 300px;
    }

    .term-modal-main-wrapper .modal-content {
        height: 460px;
    }
}
  
  @media (min-width: 768px) and (max-width: 1024px) {
    /* .modal-dialog.cancelorder-modal-main-wrapper.modal-lg.modal-dialog-centered {
        position: absolute;
        right: 0;
        top: -30px;
    }

    .modal-logo-wrap img {
        width: 82px;
        position: absolute;
        top: -26px;
        left: -30px;
    }

    .cancel-modal-content-wrap h3 {
        font-size: 20px;
    }

    .cancel-modal-content-wrap {
        margin-top: 50px;
    }

    .cancel-order-reason-wrapper {
        margin-top: 30px;
    }

    .cancelorder-modal-main-wrapper .modal-content {
        position: relative;
        width: 500px;
        height: auto;
        padding-bottom: 20px;
    }

    .mobile-cancel-modal-head {
        display: flex;
        align-items: center;
        justify-content: space-between;
    } */
    
    .modal-dialog.cancelorder-modal-main-wrapper.modal-lg.modal-dialog-centered {
        display: unset;
        margin-right: 0px;
        position: absolute;
        right: 80px;
    }

    .cancelorder-modal-main-wrapper .modal-content {
        position: relative;
        width: 600px;
    }
  
  }
  
  @media (min-width: 1025px) and (max-width: 1199px) {
    .confirmation-modal-main-wrapper .modal-content {
        min-width: 480px;
    }

    .two-confirmation-modal-main-wrapper .modal-content {
        min-width: 480px;
    }

    .modal-logo-wrap img {
        width: 82px;
        position: absolute;
        top: -26px;
        left: -30px;
    }

    .cancel-modal-content-wrap h3 {
        font-size: 20px;
    }

    .cancel-modal-content-wrap {
        margin-top: 50px;
    }

    .cancel-order-reason-wrapper {
        margin-top: 30px;
    }

    .cancelorder-modal-main-wrapper .modal-content {
        position: relative;
        width: 500px;
        height: auto;
        padding-bottom: 20px;
    }

    .percentage-modal-image {
        margin-top: 20px;
        margin-bottom: 10px;
    }

  }
  
  @media (min-width: 1200px) and (max-width: 1599px) {
    .confirmation-modal-main-wrapper .modal-content {
        min-width: 480px;
    }

    .two-confirmation-modal-main-wrapper .modal-content {
        min-width: 480px;
    }

    .modal-logo-wrap img {
        width: 82px;
        position: absolute;
        top: -26px;
        left: -30px;
    }

    .cancel-modal-content-wrap h3 {
        font-size: 20px;
    }

    .cancel-modal-content-wrap {
        margin-top: 50px;
    }

    .cancel-order-reason-wrapper {
        margin-top: 30px;
    }

    .cancelorder-modal-main-wrapper .modal-content {
        position: relative;
        width: 500px;
        height: auto;
        padding-bottom: 20px;
    }

    .percentage-modal-image {
        margin-top: 20px;
        margin-bottom: 10px;
    }
  
  }`, "",{"version":3,"sources":["webpack://./src/Dashboard/Modals/Modal.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,+DAA+D;EAC/D,oBAAoB;EACpB,2BAA2B;EAC3B,4BAA4B;EAC5B,8BAA8B;EAC9B,uBAAuB;AACzB;;;AAGA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,UAAU;EACV,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,SAAS;EACT,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,SAAS;AACX;;;AAGA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE;IACE,UAAU;IACV,aAAa;EACf;;;EAGA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,aAAa;AACjB;;EAEE;EACA,eAAe;EACf;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,WAAW;EACb;AACF;;;AAGA;EACE;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,gBAAgB;EAClB;;;EAGA;IACE,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,yBAAyB;IACzB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;AACF;;AAEA;EACE;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,YAAY;IACZ,aAAa;EACf;;;EAGA;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,UAAU;EACZ;;EAEA;IACE,yBAAyB;IACzB,eAAe;IACf,YAAY;EACd;;EAEA;IACE,sBAAsB;EACxB;AACF;;;;;AAKA,+CAA+C;;AAE/C;IACI,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;AAChB;;;AAGA;IACI,uBAAuB;AAC3B;;AAEA;IACI,UAAU;IACV,cAAc;IACd,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,UAAU;IACV,cAAc;IACd,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,WAAW;AACf;;;AAGA;IACI,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,mBAAmB;AACvB;;;AAGA;IACI,YAAY;IACZ,aAAa;AACjB;;;AAGA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,qCAAqC;IACrC,cAAc;IACd,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,WAAW;IACX,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,sBAAsB;IACtB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,YAAY;IACZ,SAAS;AACb;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;;AAGA;IACI,UAAU;IACV,cAAc;IACd,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,WAAW;AACf;;AAEA,yBAAyB;;AAEzB;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,yBAAiB;YAAjB,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,2BAA2B;IAC3B,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB,EAAE,mEAAmE;IAC9F,qBAAqB;IACrB,yBAAyB;EAC3B;;;;EAIA,+CAA+C;;EAE/C;IACE,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,qCAAqC;AACzC;;;;EAIE;IACE,qBAAqB;IACrB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,cAAc;IACd,yBAAiB;YAAjB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,eAAe;IACf,SAAS;IACT,QAAQ;EACV;;EAEA;IACE,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,YAAY;IACZ,WAAW;IACX,yBAAyB,EAAE,4BAA4B;IACvD,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,oCAAoC;AACxC;;EAEE;IACE,yBAAyB,EAAE,kCAAkC;EAC/D;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,SAAS;IACT,QAAQ;IACR,UAAU;IACV,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,wBAAwB;EAC1B;;;AAGF;IACI,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,YAAY;IACZ,aAAa;IACb,YAAY;IACZ,aAAa;IACb,aAAa;AACjB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;;AAGA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,WAAW;AACf;;;AAGA;IACI,WAAW;IACX,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,yBAAyB;IACzB,qCAAqC;AACzC;;AAEA,2CAA2C;AAC3C;IACI,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,cAAc;IACd,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;AAC3B;;;AAGA;IACI,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,UAAU;IACV,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,UAAU;IACV,WAAW;AACf;;AAEA,2BAA2B;AAC3B;IACI;QACI,kBAAkB;QAClB,cAAc;QACd,aAAa;QACb,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,kBAAkB;QAClB,cAAc;QACd,aAAa;QACb,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;QAClB,SAAS;QACT,WAAW;IACf;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,WAAW;QACX,kBAAkB;QAClB,UAAU;QACV,WAAW;IACf;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,gBAAgB;QAChB,kBAAkB;IACtB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,kBAAkB;QAClB,cAAc;QACd,aAAa;IACjB;;IAEA;QACI,WAAW;QACX,aAAa;IACjB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,iBAAiB;IACrB;;IAEA;OACG,gBAAgB;IACnB;;IAEA;QACI,aAAa;QACb,uBAAuB;QACvB,SAAS;IACb;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,kBAAkB;IACtB;;IAEA;QACI,WAAW;QACX,aAAa;IACjB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,eAAe;QACf,UAAU;IACd;;EAEF;;EAEA;IACE;QACI,aAAa;IACjB;EACF;;;AAGF;IACI;QACI,UAAU;IACd;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,kBAAkB;QAClB,UAAU;QACV,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;AACJ;;EAEE;IACE;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;OAoCG;;IAEH;QACI,cAAc;QACd,iBAAiB;QACjB,kBAAkB;QAClB,WAAW;IACf;;IAEA;QACI,kBAAkB;QAClB,YAAY;IAChB;;EAEF;;EAEA;IACE;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,kBAAkB;QAClB,UAAU;QACV,WAAW;IACf;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;QAClB,YAAY;QACZ,YAAY;QACZ,oBAAoB;IACxB;;IAEA;QACI,gBAAgB;QAChB,mBAAmB;IACvB;;EAEF;;EAEA;IACE;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,kBAAkB;QAClB,UAAU;QACV,WAAW;IACf;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;QAClB,YAAY;QACZ,YAAY;QACZ,oBAAoB;IACxB;;IAEA;QACI,gBAAgB;QAChB,mBAAmB;IACvB;;EAEF","sourcesContent":[".modal-content {\n  position: relative;\n  width: 568px !important;\n  height: 413px;\n  text-align: center;\n  margin: 0 auto;\n  /* background-image: url(\"../../assets/images/modal-bg.png\"); */\n  background-size: 45%;\n  background-position: center;\n  background-repeat: no-repeat;\n  border-radius: 21px !important;\n  border: none !important;\n}\n\n\n.modal-lotte-wrap{\n  width: 300px;\n  height: 250px;\n}\n\n.modal-side-image-wrap {\n  position: absolute;\n  top: -80px;\n  left: -50px;\n}\n\n.modal-main-wrapper h4 {\n  font-size: 26px;\n  color: #383838;\n  margin-top: 15px;\n}\n\np.contract-modal-text {\n  color: #383838 !important;\n  font-size: 24px;\n  width: 95%;\n  margin-top: 15px !important;\n}\n\n.modal-header .btn-close {\n  border: 3px solid #5e5e5e;\n  border-radius: 100%;\n  outline: none;\n  font-size: 15px;\n  color: #5e5e5e;\n  font-weight: 900;\n}\n\n.modal-header {\n  padding: 2rem 2rem;\n}\n\n.modal-header img {\n  text-align: left;\n  position: absolute;\n  right: 20px;\n  right: 25px;\n  top: 15px;\n  width: 35px;\n  cursor: pointer;\n}\n\n.modal-header .btn-close:hover {\n  border: 3px solid #000;\n}\n\n.btn-close:focus {\n  box-shadow: none;\n}\n\n.modal-header {\n  border-bottom: none;\n}\n\n.modal-main-wrapper h3 {\n  width: 80%;\n  font-size: 22px;\n  line-height: 36px;\n  color: #7E7E7E;\n  font-family: 'Montserrat';\n  text-align: center;\n  font-weight: 500;\n  margin-top: 30px;\n}\n\n.modal-main-wrapper .cancel-btn img {\n  position: absolute;\n  top: 0px;\n  right: 10px;\n  width: 40px;\n  cursor: pointer;\n}\n\n.modal-main-wrapper img {\n  width: 100px;\n  margin-top: 50px;\n}\n\n.activate-modal-img {\n  width: 120px;\n  margin-top: 20px !important;\n}\n\n.modal-side-image-wrap img {\n  width: 122px;\n}\n\nimg.dany-modal-img {\n  width: 130px;\n  margin-top: -50px;\n}\n\n.modal-main-wrapper p {\n  color: #818181;\n  font-size: 21px;\n  margin-top: 30px;\n  width: 90%;\n}\n\n.modal-main-wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n}\n\n.create-pin-wrap {\n  margin-top: 20px;\n}\n\n.Re-enter-pin {\n  margin-top: 30px;\n}\n\n.create-pin-wrap h2,\n.Re-enter-pin h2 {\n  font-size: 25px;\n  color: #383838;\n  padding-bottom: 4px;\n}\n\n.Re-enter-pin p {\n  padding-top: 10px;\n  font-size: 14px;\n  color: red;\n}\n\n.confirm-button button {\n  background: var(--buttonColor);\n  border-radius: 5px;\n  opacity: 1;\n  border: none;\n  color: #383838;\n  padding: 9px 35px;\n  margin-top: 20px;\n}\n.confirm-button button:hover {\n  background: var(--buttonHover);\n}\n\n.modal-confirm-button button {\n  background: var(--buttonColor);\n  border-radius: 5px;\n  opacity: 1;\n  border: none;\n  color: #383838;\n  padding: 9px 35px;\n  margin-top: 15px;\n  font-size: 20px;\n  font-weight: 400;\n}\n\nbutton.loding-btn {\n  padding: 0px 35px;\n}\n\n.modal-confirm-button button img {\n  width: 74px;\n  height: 50px;\n  padding: 0px;\n  margin-top: 0px;\n}\n\n.modal-confirm-button button:hover {\n  background: var(--buttonHover);\n}\n\n.modal-confirmation-button{\n  width: 480px;\n  display: flex;\n  align-items: center;\n  justify-self: center;\n  gap: 20px;\n}\n\n\n.modal-confirmation-button button {\n  width: 100%;\n  height: 55px;\n  border: none;\n  border-radius: 11px;\n  font-size: 20px;\n}\n\n.confirmation-modal-wrap{\n  display: flex;\n  margin-top: 100px;   \n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  gap: 90px;\n}\n\nbutton.confirm-btn {\n  background: #00A19B;\n  color: #fff;\n}\n\nbutton.confirm-btn:hover{\n  background: #fff;\n  color: #383838;\n  border: 2px solid #00A19B;\n}\n\nbutton.cancel-btn{\n  background: #BFBFBF;\n  color: #383838;\n}\n\nbutton.cancel-btn:hover{\n  background: #fff;\n  color: #383838;\n  border: 2px solid #BFBFBF;\n}\n\n@media (max-width: 767px) {\n  .modal-content{\n    width: 95%;\n    height: 400px;\n  }\n\n\n  .modal-side-image-wrap img {\n    width: 100px;\n  }\n\n  .modal-lotte-wrap {\n    width: 270px;\n    height: 240px;\n}\n\n  .modal-main-wrapper h3 {\n  font-size: 22px;\n  }\n\n  .modal-side-image-wrap {\n    position: absolute;\n    top: -75px;\n    left: -39px;\n  }\n}\n\n\n@media (min-width: 1600px) {\n  .modal-confirm-button button {\n    font-size: 20px;\n    font-weight: 600;\n  }\n\n  .modal-header img {\n    width: unset;\n  }\n\n  .activate-modal-img {\n    width: 180px;\n    margin-top: 50px;\n  }\n\n\n  img.dany-modal-img {\n    width: 150px;\n    margin-top: -50px;\n  }\n\n  p.contract-modal-text {\n    color: #383838 !important;\n    font-size: 31px;\n  }\n\n  .modal-main-wrapper h4 {\n    font-size: 34px;\n    margin: 30px 0px;\n  }\n\n  .modal-content {\n    width: 568px;\n    height: 413px;\n  }\n}\n\n@media (min-width: 1920px) {\n  .modal-confirm-button button {\n    font-size: 20px;\n    font-weight: 600;\n  }\n  .modal-content {\n    width: 568px;\n    height: 413px;\n  }\n\n\n  .activate-modal-img {\n    width: 180px;\n    margin-top: 50px;\n  }\n\n  .modal-main-wrapper img {\n    width: 130px;\n    margin-top: 50px;\n  }\n\n  img.dany-modal-img {\n    width: 220px;\n    margin-top: -30px;\n  }\n\n  .modal-main-wrapper p {\n    color: #818181;\n    font-size: 30px;\n  }\n\n  p.contract-modal-text {\n    color: #383838 !important;\n    font-size: 28px;\n    font-weight: 500;\n    width: 90%;\n  }\n\n  .modal-header .btn-close {\n    border: 4px solid #5e5e5e;\n    font-size: 20px;\n    padding: 8px;\n  }\n\n  .modal-header .btn-close:hover {\n    border: 4px solid #000;\n  }\n}\n\n\n\n\n/************ Cleaning yfos modal css here ****/\n\n.confirmation-modal-main-wrapper .modal-content {\n    position: relative;\n    min-width: 568px;\n    height: 310px;\n    background: #FFFFFF;\n    border-radius: 34px;\n    border: none;\n}\n\n.term-modal-main-wrapper .modal-content {\n    position: relative;\n    width: 450px;\n    height: 400px;\n    background: #FFFFFF;\n    border-radius: 10px;\n    border: none;\n}\n\n\n.modal-lg, .modal-xl {\n    --bs-modal-width: unset;\n}\n\n.confirm-modal-main-wrap {\n    width: 87%;\n    margin: 0 auto;\n    text-align: center;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n}\n\n.term-modal-main-wrap {\n    width: 86%;\n    margin: 0 auto;\n    text-align: center;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n}\n\n.modal-logo-wrap img {\n    width: 112px;\n    position: absolute;\n    top: -36px;\n    left: -40px;\n}\n\n\n.confirm-modal-main-wrap .modal-content {\n    width: 568px;\n    height: 309px;\n}\n\n.confirm-tick-image {\n    margin-bottom: 10px;\n}\n\n\n.confirm-tick-image img {\n    width: 116px;\n    height: 116px;\n}\n\n\n.confirm-tick-image h4 {\n    font-size: 56px;\n    color: #00A19B;\n    font-weight: 700;\n    margin-top: 30px;\n}\n\n.confirm-modal-content-wrap h3 {\n    font-size: 26px;\n    font-family: \"Montserrat\", sans-serif;\n    color: #1A1919;\n    font-weight: 700 !important;\n    margin-bottom: 10px;\n}\n\n.confirm-modal-content-wrap p {\n    font-size: 22px;\n    color: #1A1919;\n    font-weight: 400;\n    margin: 0 auto;\n}\n\n.percentage-modal-content-wrap h3 {\n    font-size: 25px;\n    color: #1A1919;\n    font-weight: bold;\n    margin: 0px;\n    /* text-align: left; */\n    margin-bottom: 15px;\n}\n\n.percentage-modal-image{\n    margin-top: 30px;\n    margin-bottom: 12px;\n}\n\n.percentage-modal-image h4 {\n    font-size: 60px;\n    color: #00A19B;\n    font-weight: bold;\n    /* text-align: left; */\n    margin: 0px;\n    padding-bottom: 8px;\n}\n\n.percentage-modal-content-wrap p {\n    font-size: 14px;\n    font-weight: 400;\n    margin: 0px;\n    text-align: left;\n}\n\n.percentage-modal-content-wrap span {\n    font-size: 14px;\n    font-weight: 400;\n    color: #00A19B;\n    font-style: italic;\n    margin: 0px;\n    text-align: left;\n}\n\n.percentage-modal-content-wrap {\n    position: relative;\n}\n\n.percentage-item-warp {\n    /* display: flex; */\n    display: none;\n    align-items: center;\n    gap: 2px;\n    position: absolute;\n    right: -40px;\n    top: 80px;\n}\n\n.percentage-item-warp p{\n    font-size: 14px;\n    color: #1A1919;\n    font-weight: 600;\n    margin-top: 10px;\n}\n\n.percentage-item-warp img{\n    width: 40px;\n}\n\n.close-icon-wrap {\n    position: absolute;\n    top: 26px;\n    right: 40px;\n    z-index: 999;\n}\n\n.close-icon-wrap img{\n    width: 32px;\n    cursor: pointer;\n}\n\n\n.cancel-modal-main-wrap {\n    width: 80%;\n    margin: 0 auto;\n    text-align: left;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n}\n\n.cancel-modal-content-wrap {\n    margin-top: 70px;\n}\n\n.cancel-modal-content-wrap h3 {\n    font-size: 25px;\n    color: #1A1919;\n    font-weight: bold;\n    text-align: left;\n}\n\n.cancel-modal-content-wrap label {\n    font-size: 16px;\n    color: #1A1919;\n    font-weight: 400;\n    margin: 0px;\n}\n\n/* CancelOrderModal.css */\n\n.cancelorder-modal-main-wrapper .modal-content {\n    position: relative;\n    width: 568px;\n    height: 780px;\n    background: #FFFFFF;\n    border-radius: 34px;\n    border: none;\n}\n\n.cancel-order-reason-wrapper{\n    margin-top: 40px;\n}\n\n.radio-option {\n    display: flex;\n    align-items: center;\n    margin-bottom: 20px;\n  }\n  \n  .radio-option input[type=\"radio\"] {\n    display: none;\n  }\n  \n  .radio-option label {\n    position: relative;\n    padding-left: 30px;\n    cursor: pointer;\n    user-select: none;\n  }\n  \n  .radio-option label::before {\n    content: \"\";\n    position: absolute;\n    left: 0;\n    top: 50%;\n    transform: translateY(-50%);\n    width: 20px;\n    height: 20px;\n    border: none;\n    border-radius: 50%;\n    background-color: #F3F3F3;\n  }\n  \n  .radio-option input[type=\"radio\"]:checked + label::before {\n    background-color: #00A19B; /* Change this color to the desired background color when checked */\n    border-color: #4caf50;\n    border: 2px solid #F3F3F3;\n  }\n\n\n\n  /************* Change select box backround ****/\n\n  .term-modal-checkmark-wrap {\n    display: flex;\n    gap: 36px;\n    margin-bottom: 16px;\n}\n\n.term-modal-checkmark-wrap p{\n    font-size: 14px;\n    font-weight: 400;\n    margin: 0px;\n    color: #626262;\n}\n\n.term-modal-checkmark-wrap p a{\n    color: #00A19B !important;\n    text-decoration: underline !important;\n}\n\n\n\n  .checkbox-container {\n    display: inline-block;\n    position: relative;\n    margin-bottom: 0px;\n    cursor: pointer;\n    font-size: 14px;\n    color: #1A1919;\n    user-select: none;\n  }\n  \n  .checkbox-container input {\n    position: absolute;\n    opacity: 0;\n    cursor: pointer;\n    height: 0;\n    width: 0;\n  }\n  \n  .checkbox-container .checkmark {\n    position: absolute;\n    top: 0;\n    left: 0;\n    height: 22px;\n    width: 22px;\n    background-color: #f3f3f3; /* default gray background */\n    border-radius: 0px;\n    border: none;\n  }\n\n  span.error-msg.checkmark {\n    border: 1px solid #FF0000 !important;\n}\n  \n  .checkbox-container input:checked ~ .checkmark {\n    background-color: #00A19B; /* background color when checked */\n  }\n  \n  .checkbox-container .checkmark:after {\n    content: \"\";\n    position: absolute;\n    display: none;\n  }\n  \n  .checkbox-container input:checked ~ .checkmark:after {\n    display: block;\n  }\n  \n  .checkbox-container .checkmark:after {\n    left: 9px;\n    top: 5px;\n    width: 5px;\n    height: 10px;\n    border: solid white;\n    border-width: 0 2px 2px 0;\n    transform: rotate(45deg);\n  }\n  \n\n.cancel-booking-main-wrap textarea {\n    border: none;\n    border-radius: 20px;\n    background-color: #F3F3F3;\n    width: 404px;\n    height: 166px;\n    resize: none;\n    padding: 20px;\n    outline: none;\n}\n\n.disable-textarea{\n    opacity: 0.6;\n}\n\n.cancel-booking-main-wrap textarea::placeholder{\n    font-size: 16px;\n    color: #D5D5D5;\n    font-weight: 400;\n}\n\n.cancel-booking-btn{\n    margin-top: 20px;\n}\n\n\n.specaility-modal-content-wrap {\n    text-align: left;\n    margin-top: 50px;\n}\n\n.specaility-modal-content-wrap h3 {\n    font-size: 25px;\n    font-weight: bold;\n    margin: 0px;\n    padding-bottom: 8px;\n}\n\n.specaility-modal-content-wrap p {\n    font-size: 14px;\n    color: #1A1919;\n    font-weight: 400;\n    margin: 0px;\n}\n\n.modal-leave-stay-btn-wrap{\n    margin-top: 50px;\n}\n\n.modal-leave-stay-btn {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 10px;\n    margin-top: 10px;\n}\n\n.modal-leave-stay-btn button{\n    height: 49px;\n    width: 50%;\n}\n\n.term-modal-content-wrap {\n    text-align: left;\n}\n\n.term-modal-content-wrap h3 {\n    font-size: 22px;\n    color: #1A1919;\n    font-weight: 600;\n    margin: 0px;\n}\n\n.term-modal-content-wrap p {\n    font-size: 14px;\n    color: #1A1919;\n    font-weight: 400;\n    margin: 0px;\n}\n\n\n.term-modal-content-wrap img {\n    width: 22px;\n    margin-bottom: 10px;\n    margin-top: 10px;\n}\n\n.term-condition-content{\n    margin-top: 12px;\n}\n\n.term-condition-content p {\n    font-size: 14px;\n    color: #626262;\n    font-weight: 400;\n    margin: 0px;\n    text-align: left;\n}\n\n.pay-modal-term-wrapper{\n    margin-top: 40px;\n}\n\n.pay-modal-term-wrapper label{\n    font-size: 14px;\n    color: #626262;\n    font-weight: 400;\n    margin: 0;\n}\n\n.pay-modal-term-wrapper label a {\n    color: #00A19B !important;\n    text-decoration: underline !important;\n}\n\n/******* TwoFa Confirmation Modal css *****/\n.two-confirmation-modal-main-wrapper .modal-content {\n    position: relative;\n    min-width: 568px;\n    height: 310px;\n    background: #FFFFFF;\n    border-radius: 34px;\n    border: none;\n}\n\n.two-confirmation-modal-main-wrapper .modal-body{\n    padding: 0px;\n}\n\n.twofa-confirm-modal-main-wrap {\n    width: 87%;\n    margin: 0 auto;\n    text-align: center;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n}\n\n\n.modal-logo-wrap img {\n    width: 112px;\n    position: absolute;\n    top: -36px;\n    left: -40px;\n}\n\n.twofa-confirm-tick-image img {\n    width: 205px;\n}\n\n.twofa-confirm-modal-content-wrap p {\n    font-size: 22px;\n    width: 80%;\n    color: #1A1919;\n    font-weight: 500;\n    line-height: normal;\n    margin: 0 auto;\n}\n\np.error-msg {\n    font-size: 14px;\n    color: #FF0000;\n    margin: 0px;\n    overflow: hidden;\n}\np.error-msg-empty{\n    opacity: 0;\n    margin: 0px;\n}\n\n/******* Resposive css ****/\n@media (max-width: 1024px) {\n    .two-confirmation-modal-main-wrapper .modal-content {\n        position: relative;\n        min-width: 90%;\n        height: 240px;\n        margin: 0 auto;\n        border-radius: 23px;\n    }\n\n    .twofa-confirm-tick-image img {\n        width: 156px;\n    }\n\n    .fade.modal.show {\n        z-index: 999999;\n    }\n\n    .confirmation-modal-main-wrapper .modal-content {\n        position: relative;\n        min-width: 90%;\n        height: 240px;\n        margin: 0 auto;\n        border-radius: 23px;\n    }\n\n    .speciality-modal-main-wrapper .modal-content {\n        height: 290px;\n    }\n\n    .specaility-modal-content-wrap h3 {\n        font-size: 18px;\n        font-weight: bold;\n    }\n\n    .specaility-modal-content-wrap {\n        margin-top: 36px;\n    }\n\n    .modal-leave-stay-btn-wrap {\n        margin-top: 40px;\n    }\n\n    .close-icon-wrap {\n        position: absolute;\n        top: 16px;\n        right: 20px;\n    }\n\n    .confirm-modal-content-wrap h3 {\n        font-size: 20px;\n        font-weight: bold;\n        margin-bottom: 5px;\n    }\n\n    .confirm-modal-content-wrap p {\n        font-size: 16px;\n    }\n\n    .confirm-tick-image h4 {\n        font-size: 50px;\n        margin-top: 20px;\n        margin-bottom: 0px;\n    }\n\n    .confirm-tick-image {\n        margin-bottom: 0px;\n    }\n\n    .modal-logo-wrap img {\n        width: 80px;\n        position: absolute;\n        top: -30px;\n        left: -12px;\n    }\n\n    .confirm-tick-image img {\n        width: 90px;\n        height: 90px;\n    }\n\n    .percentage-modal-image h4 {\n        font-size: 40px;\n        font-weight: bold;\n    }\n\n    .percentage-modal-content-wrap h3 {\n        font-size: 16px;\n        margin-bottom: 8px;\n    }\n\n    .percentage-item-warp {\n        display: none;\n    }\n\n    .percentage-modal-image {\n        margin-top: 10px;\n        margin-bottom: 4px;\n    }\n\n    .confirm-modal-main-wrap {\n        width: 86%;\n    }\n\n    .percentage-modal-main-wrapper .modal-content {\n        position: relative;\n        min-width: 90%;\n        height: 270px;\n    }\n\n    .term-modal-main-wrapper .modal-content {\n        width: 100%;\n        height: 430px;\n    }\n\n    .pay-modal-term-wrapper {\n        margin-top: 30px;\n    }\n\n    .term-modal-main-wrapper .pay-button-wrapper button {\n        height: 49px;\n        font-size: 14px;\n    }\n\n    .term-modal-main-wrapper .pay-button-wrapper {\n        margin-top: 14px;\n    }\n\n    .cancelorder-modal-main-wrapper .modal-content {\n        position: relative;\n        width: 100%;\n        min-height: 100vh;\n    }\n\n    .cancelorder-modal-main-wrapper .modal-body {\n       background: #fff;\n    }\n\n    .mobile-cancel-modal-head {\n        display: flex;\n        align-items: flex-start;\n        gap: 10px;\n    }\n\n    .cancel-modal-content-wrap h3 {\n        font-size: 20px;\n        font-weight: 600;\n        margin-bottom: 0px;\n    }\n\n    .cancel-booking-main-wrap textarea {\n        width: 100%;\n        height: 220px;\n    }\n\n    .cancel-modal-main-wrap {\n        width: 100%;\n    }\n\n    .cancel-modal-content-wrap {\n        margin-top: 40px;\n    }\n\n    .mobile-cancel-modal-head img {\n        width: 36px;\n    }\n\n    .twofa-confirm-modal-content-wrap p {\n        font-size: 16px;\n        width: 90%;\n    }\n\n  }\n\n  @media(max-width: 360px){\n    .term-modal-main-wrapper .modal-content {\n        height: 460px;\n    }\n  }\n  \n  \n@media(max-width: 340px){\n    .confirm-modal-main-wrap {\n        width: 94%;\n    }\n\n    .percentage-modal-content-wrap h3 {\n        font-size: 15px;\n    }\n\n    .percentage-modal-main-wrapper .modal-content {\n        position: relative;\n        width: 90%;\n        height: 300px;\n    }\n\n    .term-modal-main-wrapper .modal-content {\n        height: 460px;\n    }\n}\n  \n  @media (min-width: 768px) and (max-width: 1024px) {\n    /* .modal-dialog.cancelorder-modal-main-wrapper.modal-lg.modal-dialog-centered {\n        position: absolute;\n        right: 0;\n        top: -30px;\n    }\n\n    .modal-logo-wrap img {\n        width: 82px;\n        position: absolute;\n        top: -26px;\n        left: -30px;\n    }\n\n    .cancel-modal-content-wrap h3 {\n        font-size: 20px;\n    }\n\n    .cancel-modal-content-wrap {\n        margin-top: 50px;\n    }\n\n    .cancel-order-reason-wrapper {\n        margin-top: 30px;\n    }\n\n    .cancelorder-modal-main-wrapper .modal-content {\n        position: relative;\n        width: 500px;\n        height: auto;\n        padding-bottom: 20px;\n    }\n\n    .mobile-cancel-modal-head {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n    } */\n    \n    .modal-dialog.cancelorder-modal-main-wrapper.modal-lg.modal-dialog-centered {\n        display: unset;\n        margin-right: 0px;\n        position: absolute;\n        right: 80px;\n    }\n\n    .cancelorder-modal-main-wrapper .modal-content {\n        position: relative;\n        width: 600px;\n    }\n  \n  }\n  \n  @media (min-width: 1025px) and (max-width: 1199px) {\n    .confirmation-modal-main-wrapper .modal-content {\n        min-width: 480px;\n    }\n\n    .two-confirmation-modal-main-wrapper .modal-content {\n        min-width: 480px;\n    }\n\n    .modal-logo-wrap img {\n        width: 82px;\n        position: absolute;\n        top: -26px;\n        left: -30px;\n    }\n\n    .cancel-modal-content-wrap h3 {\n        font-size: 20px;\n    }\n\n    .cancel-modal-content-wrap {\n        margin-top: 50px;\n    }\n\n    .cancel-order-reason-wrapper {\n        margin-top: 30px;\n    }\n\n    .cancelorder-modal-main-wrapper .modal-content {\n        position: relative;\n        width: 500px;\n        height: auto;\n        padding-bottom: 20px;\n    }\n\n    .percentage-modal-image {\n        margin-top: 20px;\n        margin-bottom: 10px;\n    }\n\n  }\n  \n  @media (min-width: 1200px) and (max-width: 1599px) {\n    .confirmation-modal-main-wrapper .modal-content {\n        min-width: 480px;\n    }\n\n    .two-confirmation-modal-main-wrapper .modal-content {\n        min-width: 480px;\n    }\n\n    .modal-logo-wrap img {\n        width: 82px;\n        position: absolute;\n        top: -26px;\n        left: -30px;\n    }\n\n    .cancel-modal-content-wrap h3 {\n        font-size: 20px;\n    }\n\n    .cancel-modal-content-wrap {\n        margin-top: 50px;\n    }\n\n    .cancel-order-reason-wrapper {\n        margin-top: 30px;\n    }\n\n    .cancelorder-modal-main-wrapper .modal-content {\n        position: relative;\n        width: 500px;\n        height: auto;\n        padding-bottom: 20px;\n    }\n\n    .percentage-modal-image {\n        margin-top: 20px;\n        margin-bottom: 10px;\n    }\n  \n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
